import { render } from "./Location.vue?vue&type=template&id=18c12f8c&scoped=true"
const script = {}

import "./Location.vue?vue&type=style&index=0&id=18c12f8c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c12f8c"]])

export default __exports__